import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  Modal,
  Row,
  Col,
  CloseButton,
  Badge,
} from "react-bootstrap";
import * as yup from "yup";
import { getCarrierData } from "../../../api/User/Hub/medicalcredentialsApi";
import Fontstyling from "../../../components/common/comman";
import {
  GetClientsMedicalPlanFundingType,
  GetClientsMedicalPlanStopLossInsurer,
  GetClientsMedicalPlanType,
  GetFeeByFundingArrangement,
  GetFeeType,
  GetSubFeeByMainFee,
} from "../../../api/User/Hub/medicalplanApi";
import AddIcon from "../../../assets/icon/circle-plus-solid.svg";
import {
  GetClientsVisionPlanDetailsByID,
  SaveClientsVisionPlanDetails,
} from "../../../api/User/Hub/visionPlanSetUpApi";
import ReactTooltip from "react-tooltip";
import Required from "../../Required";
import FeesBadge from "../Hub/feesBadge";
import moment from "moment";

const schema = yup.object().shape({
  Carrier: yup
    .string()
    .notOneOf(["Select Carrier"], "Please enter carrier")
    .required("Please enter carrier"),
  FundingArrangement: yup
    .string()
    .notOneOf(
      ["Select Funding Arrangement"],
      "Please select funding arrangement"
    )
    .required("Please select funding arrangement"),
  ContractStart: yup.date().required("Please enter contract start date"),
  ContractEnd: yup.date().required("Please enter contract end date"),
  PlanName: yup.string().required("Please enter plan name"),
  PlanType: yup.string().required("Please enter plan type"),
  TierType: yup.string().required("Please enter tier type"),
});

const VisionPlanModal = ({
  show,
  onHide,
  witchAction,
  user,
  client,
  updateData,
  setResponseMessage,
  getData,
}) => {
  const [CarrierData, setCarrierData] = useState([]);
  const [FundingTypes, setFundingTypes] = useState([]);
  const [medicalPlanType, setMedicalPlanType] = useState([]);
  const [isFeesSection, setIsFeesSection] = useState(false);
  const [length20Error, setLength20Error] = useState(null);
  const [FeeTypeError, setFeeTypeError] = useState(false);
  const [feesArrays, setFeesArrays] = useState(null);
  const [feesData, setFeesData] = useState([]);
  const [feeTypes, setFeeTypes] = useState([]);
  const [prevFundFees, setPrevFundFees] = useState([]);
  const buttonRef = useRef(null);
  const formikFeesRef = useRef();
  const categoryID = 3;

  useEffect(() => {
    getFundingData();
    getCarrier();
    // getStopLoseData();
    getPlanType();
    getFeeTypes();
    if (witchAction === "update") {
      getPlanDetailById();
    }
  }, []);

  const getPlanDetailById = () => {
    GetClientsVisionPlanDetailsByID(
      client?.clientID,
      user?.UD_id,
      updateData?.CVisionPlanID
    )
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          //console.log(res.data);
          let prevFees = null;
          if (
            !(
              res.data[0]?.cVisionPlanFees === null ||
              res.data[0]?.cVisionPlanFees[0]?.cVisionPlanMainFees[0]
                ?.cVisionPlanSubFees.length === 0
            )
          ) {
            let planMainFees =
              res?.data[0]?.cVisionPlanFees[0]?.cVisionPlanMainFees;
            prevFees = planMainFees?.length
              ? planMainFees?.reduce(
                  (result, f) => ({
                    ...result,
                    [f.feeName]: f.cVisionPlanSubFees,
                  }),
                  {}
                )
              : null;
          }
          // console.log({ prevFees });
          setPrevFundFees(prevFees);
          let funding = {
            MedFundTypeID: updateData.CVisionPlanFundingID,
            MedFundName: updateData.FundingName,
          };
          onFundArrangementChange(funding, prevFees);
        }
      })
      .catch((err) => console.log(err));
  };

  const getCarrier = () => {
    getCarrierData().then((res) => {
      setCarrierData(() =>
        res.data.sort((a, b) => {
          if (a.CarrierName < b.CarrierName) {
            return -1;
          }
          if (a.CarrierName > b.CarrierName) {
            return 1;
          }
          return 0;
        })
      );
    });
  };

  const getFundingData = () => {
    GetClientsMedicalPlanFundingType().then((res) =>
      setFundingTypes(() =>
        res.data.sort((a, b) => {
          if (a.MedFundName < b.MedFundName) {
            return -1;
          }
          if (a.MedFundName > b.MedFundName) {
            return 1;
          }
          return 0;
        })
      )
    );
  };

  const getPlanType = () => {
    GetClientsMedicalPlanType().then((res) =>
      setMedicalPlanType(() =>
        res.data.sort((a, b) => {
          if (a.PlanTypeName < b.PlanTypeName) {
            return -1;
          }
          if (a.PlanTypeName > b.PlanTypeName) {
            return 1;
          }
          return 0;
        })
      )
    );
  };

  const getFeeTypes = () => {
    GetFeeType().then((feeTypeRes) => {
      // console.log({ feeTypeRes })
      setFeeTypes(feeTypeRes.data);
    });
  };

  const handelSubmit = async (e, bag) => {
    let ContractStart = new Date(e.ContractStart).toISOString();
    let ContractEnd = new Date(e.ContractEnd).toISOString();
    let carrierData = JSON.parse(e.Carrier);
    let fundArrangeData = JSON.parse(e.FundingArrangement);
    let CVisionPlanMainFees = [];
    for (let key in feesArrays) {
      if (feesArrays[key]?.length) {
        CVisionPlanMainFees.push({
          feeID: feesData.find((f) => f.FeeName === key).FeeID,
          feeName: key,
          cVisionPlanSubFees: feesArrays[key].map((el) => ({
            subFeeID: el.subFeeID,
            subFeeName:
              el.subFeeName === "Create new fee"
                ? el.subFeeNameAlias
                : el.subFeeName,
            subFeeNameAlias:
              el.subFeeName === "Create new fee"
                ? ""
                : el.subFeeNameAlias
                ? el.subFeeNameAlias
                : "",
            feeTypeID: el.feeTypeID,
            feeTypeName: el.feeTypeName,
            feeTypeNameAlias: el.feeTypeNameAlias,
            amount: +el.amount,
            // ...el.budgetedMonth &&{ budgetedMonth: el.budgetedMonth},
            budgetedMonth: el.budgetedMonth ?? null,
            isfeeUserDefine: el.isfeeUserDefine,
          })),
        });
      }
    }
    let payload = {
      cVisionPlanID: witchAction === "add" ? 0 : updateData.CVisionPlanID,
      cVisionPlanClientID: client?.clientID,
      cVisionPlanUserID: user?.UD_id,
      cVisionPlanRegionID: client?.regionId,
      cVisionPlanCarrierID: +carrierData.CarrierID,
      cVisionPlanContractStart: ContractStart,
      cVisionPlanContractEnd: ContractEnd,
      cVisionPlanFundingID: +fundArrangeData.MedFundTypeID,
      cVisionPlanName: e.PlanName,
      cVisionPlanType: e.PlanType,
      cVisionPlanTierType: e.TierType,
      cVisionPlanCreatedBy: user?.UD_id,
      cVisionPlanFees: [
        {
          cVisionPlanID: witchAction === "add" ? 0 : updateData.CVisionPlanID,
          clientID: client?.clientID,
          clientName: client?.clientName,
          categoryName: "Vision",
          medFundName: fundArrangeData.MedFundName,
          carrierName: carrierData.CarrierName,
          cVisionPlanMainFees: CVisionPlanMainFees,
        },
      ],
    };

    buttonRef.current.disabled = true;
    await SaveClientsVisionPlanDetails(payload).then((res) => {
      if (res.status === 200) {
        if (res.data === "Requested region is rejected") {
          setResponseMessage("rejectedRegion");
        } else {
          setResponseMessage(res.data);
          getData();
        }
      } else {
        setResponseMessage("error");
      }
      bag.setValues({
        Carrier: "",
        ContractStart: "",
        ContractEnd: "",
        FundingArrangement: "",
        PlanName: "",
        PlanType: "",
        TierType: "",
      });
    });
    onHide();
  };

  const handleAddFees = (values, handlers, witchFees) => {
    // let BudgetedMonth = new Date(values.budgetedMonth).toISOString();
    if (
      values.isfeeUserDefine &&
      feesArrays[witchFees].filter((v) => v.isfeeUserDefine).length === 20
    ) {
      setLength20Error((prev) => ({ ...prev, [witchFees]: true }));
    } else if (
      !values.isfeeUserDefine &&
      feesArrays[witchFees].some(
        (v) =>
          !v.isfeeUserDefine &&
          v.subFeeName === JSON.parse(values.subFee).SubFeeName &&
          v.feeTypeID === JSON.parse(values.feeType).FeeTypeID
      )
    ) {
      setFeeTypeError(true);
    } else {
      let subFee;
      let feeTypeObj = JSON.parse(values.feeType);
      let feeType = {
        feeTypeID: feeTypeObj.FeeTypeID,
        feeTypeName: feeTypeObj.FeeTypeName,
      };
      const id =
        parseInt(new Date().toISOString().replace(/[-:.TZ]/g, "")) % 100000000;
      if (!values.isfeeUserDefine) {
        let subFeeObj = JSON.parse(values.subFee);
        // subFee = { subFeeID: subFeeObj.SubFeeID, subFeeName: subFeeObj.SubFeeName }
        subFee = { subFeeID: id, subFeeName: subFeeObj.SubFeeName };
      } else {
        subFee = {
          subFeeID: id,
          subFeeName:
            values.subFee === "Create new fee"
              ? values.subFeeNameAlias
              : values.subFee,
        };
      }
      let formValues = { ...values };
      delete formValues.subFee;
      delete formValues.subFeeNameAlias;
      delete formValues.feeType;
      let badge = { ...formValues, ...subFee, ...feeType };
      // console.log({ badge });
      setFeesArrays((prev) => ({
        ...prev,
        [witchFees]: [...prev[witchFees], badge],
      }));
    }
    handlers.resetForm();
  };

  const onFundArrangementChange = (funding, prevFees) => {
    // let funding = JSON.parse(val);
    setIsFeesSection(false);
    GetFeeByFundingArrangement(categoryID, funding.MedFundTypeID).then(
      (feeRes) => {
        setIsFeesSection(true);
        let feeResData = feeRes.data;
        // console.log({ feeResData })
        let feeList = feeResData?.reduce(
          (result, f) => ({ ...result, [f.FeeName]: [] }),
          {}
        );
        let lenErrList = feeResData?.reduce(
          (result, f) => ({ ...result, [f.FeeName]: false }),
          {}
        );
        if (prevFees) {
          setFeesArrays({ ...feeList, ...prevFees });
        } else {
          setFeesArrays(feeList);
        }
        setLength20Error(lenErrList);
        let modifiedData = [];
        Promise.all(
          feeResData?.map((el) => {
            return GetSubFeeByMainFee(
              categoryID,
              funding.MedFundTypeID,
              el.FeeID
            ).then((subFeeRes) => {
              // console.log({ subFeeRes });
              modifiedData.push({ ...el, subFeeData: subFeeRes.data });
            });
          })
        ).then(() => {
          // console.log({ modifiedData });
          setFeesData(modifiedData);
        });
      }
    );
  };

  // console.log({ updateData });
  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={Fontstyling.modalHeading}
        >
          {witchAction === "add"
            ? "Add New "
            : witchAction === "update"
            ? "Update "
            : "Delete "}
          Plan
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="overflow-auto d-flex flex-column"
        style={{ maxHeight: "60vh" }}
      >
        <Formik
          validationSchema={witchAction !== "delete" && schema}
          onSubmit={handelSubmit}
          initialValues={{
            Carrier:
              updateData.Carrier && updateData.CVisionPlanCarrierID
                ? JSON.stringify({
                    CarrierID: updateData.CVisionPlanCarrierID,
                    CarrierName: updateData.Carrier,
                  })
                : "",
            ContractStart:
              updateData && updateData.CVisionPlanContractStart
                ? updateData.CVisionPlanContractStart.split("T")[0]
                : "",
            ContractEnd:
              updateData && updateData.CVisionPlanContractEnd
                ? updateData.CVisionPlanContractEnd.split("T")[0]
                : "",
            FundingArrangement:
              updateData.CVisionPlanFundingID && updateData.FundingName
                ? JSON.stringify({
                    MedFundTypeID: updateData.CVisionPlanFundingID,
                    MedFundName: updateData.FundingName,
                  })
                : "",
            PlanName: updateData ? updateData.CVisionPlanName : "",
            PlanType: updateData ? updateData.CVisionPlanType : "",
            TierType: updateData ? updateData.CVisionPlanTierType : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} id="form1">
              <Row className="mb-3 gap-3">
                <Form.Group as={Col}>
                  <Form.Label style={Fontstyling.label}>
                    Carrier <Required />{" "}
                  </Form.Label>
                  <Form.Select
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    name="Carrier"
                    value={values.Carrier}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={witchAction === "update"}
                    isInvalid={values.Carrier === "" && touched.Carrier}
                  >
                    <option value={""}>Select Carrier</option>
                    {CarrierData.map((item, index) => (
                      <option value={JSON.stringify(item)}>
                        {item.CarrierName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.Carrier}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="validationFormik02">
                  <Form.Label style={Fontstyling.label}>
                    Contract Start <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                    type="date"
                    name="ContractStart"
                    placeholder="Authorized User"
                    value={values.ContractStart}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={errors.ContractStart && touched.ContractStart}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.ContractStart}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="validationFormik03">
                  <Form.Label style={Fontstyling.label}>
                    Contract End <Required />
                  </Form.Label>
                  {witchAction === "add" && (
                    <>
                      <img
                        data-tip="Select start date first"
                        src={require("../../../assets/icon/Question_mark_back.png")}
                        style={{ height: 12, marginLeft: 3 }}
                      />
                      <ReactTooltip />
                    </>
                  )}
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                    type="date"
                    name="ContractEnd"
                    value={values.ContractEnd}
                    min={values.ContractStart}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={values.ContractStart ? false : true}
                    isInvalid={errors.ContractEnd && touched.ContractEnd}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.ContractEnd}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="validationFormik04">
                  <Form.Label style={Fontstyling.label}>
                    Funding Arrangement <Required />
                  </Form.Label>
                  <Form.Select
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    name="FundingArrangement"
                    onChange={(e) => {
                      handleChange(e);
                      let val = JSON.parse(e?.target?.value);
                      if (
                        val?.MedFundTypeID === updateData.CVisionPlanFundingID
                      ) {
                        onFundArrangementChange(val, prevFundFees);
                      } else {
                        onFundArrangementChange(val);
                      }
                    }}
                    onBlur={handleBlur}
                    disabled={witchAction === "delete"}
                    value={values.FundingArrangement}
                    isInvalid={
                      values.FundingArrangement === "" &&
                      touched.FundingArrangement
                    }
                  >
                    <option value={""}>Select Funding Arrangement</option>
                    {FundingTypes.map((item, index) => (
                      <option
                        value={JSON.stringify(item)}
                        key={index}
                        // selected={updateData.FileTypeName === item.fileTypeName}
                      >
                        {item.MedFundName}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.FundingArrangement}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3 gap-3"></Row>
              <Row className="mb-3 gap-3">
                <Form.Group as={Col} md="3" controlId="validationFormik06">
                  <Form.Label style={Fontstyling.label}>
                    Plan Name <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={Fontstyling.label}
                    type="text"
                    placeholder="Plan Name"
                    name="PlanName"
                    value={values.PlanName}
                    onChange={handleChange}
                    isInvalid={touched.PlanName && errors.PlanName}
                    disabled={witchAction === "delete"}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.PlanName}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="validationFormik07">
                  <Form.Label className="text-nowrap" style={Fontstyling.label}>
                    Plan Type <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label }}
                    type="text"
                    name="PlanType"
                    value={values.PlanType}
                    placeholder="Plan Type"
                    onChange={handleChange}
                    isInvalid={touched.PlanType && errors.PlanType}
                    disabled={witchAction === "delete"}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.PlanType}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="validationFormik09">
                  <Form.Label className="text-nowrap" style={Fontstyling.label}>
                    Tier Type <Required />
                  </Form.Label>
                  <Form.Control
                    className="rounded-0 py-1"
                    style={{ ...Fontstyling.label }}
                    type="text"
                    name="TierType"
                    value={values.TierType}
                    placeholder="Tier Type"
                    onChange={handleChange}
                    disabled={witchAction === "delete"}
                    isInvalid={touched.TierType && errors.TierType}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.TierType}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
            </Form>
          )}
        </Formik>
        {isFeesSection &&
          feesData.length > 0 &&
          feesData.map((el) => {
            let witchFees = el.FeeName;
            let initialValues = {
              subFee: "",
              subFeeNameAlias: "",
              feeType: "Select Fees Type",
              feeTypeNameAlias: "",
              amount: "",
              isfeeUserDefine: 0,
            };
            let feesSchema = {
              subFee: yup.string().required("Please enter fee"),
              feeType: yup
                .string()
                .notOneOf(["Select Fees Type"], "Please select fee type")
                .required("Please select fee type"),
              amount: yup
                .number()
                .typeError("Enter number")
                .required("Please enter amount"),
            };
            if (witchFees === "Budgeted Rates") {
              initialValues.budgetedMonth = moment()
                .startOf("month")
                .format("YYYY-MM-DD");
              feesSchema.budgetedMonth = yup
                .date()
                .max("12-31-9999", "Please enter valid date")
                .required("Please select date");
            }
            // if (formikFeesRef?.current?.values?.subFee === "Create new fee") {
            //   feesSchema.subFeeNameAlias = yup.string().required("required");
            // }
            return (
              <div className="border-top">
                <div style={Fontstyling.heading} className="my-3">
                  {el.FeeName}
                </div>
                <Formik
                  innerRef={formikFeesRef}
                  enableReinitialize
                  validationSchema={yup.object().shape(feesSchema)}
                  onSubmit={(values, handlers) =>
                    handleAddFees(values, handlers, witchFees)
                  }
                  initialValues={initialValues}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    errors,
                    setFieldValue,
                  }) => (
                    <Form onSubmit={handleSubmit} name="medicalClaims">
                      <Row className="mb-3 justify-content-start">
                        {!el.subFeeData?.length ? (
                          <Col className="px-1 my-2" xs={6} lg>
                            <Form.Group className="text-start">
                              <Form.Control
                                name="subFee"
                                className="py-1 rounded-0"
                                style={Fontstyling.label}
                                value={values.subFee}
                                maxLength={25}
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue("isfeeUserDefine", 1);
                                  setFeeTypeError(false);
                                }}
                                onBlur={handleBlur}
                                isInvalid={touched.subFee && errors.subFee}
                                type="text"
                                placeholder="Fees name"
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.subFee}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        ) : (
                          <>
                            <Col className="px-1 my-2" xs={6} lg>
                              <Form.Group className="text-start">
                                <Form.Select
                                  className="rounded-0 py-1"
                                  style={Fontstyling.label}
                                  name="subFee"
                                  value={values.subFee}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFeeTypeError(false);
                                    if (e.target.value === "Create new fee") {
                                      setFieldValue("isfeeUserDefine", 1);
                                    } else {
                                      setFieldValue("isfeeUserDefine", 0);
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  isInvalid={errors.subFee && touched.subFee}
                                >
                                  <option value={""}>Select Fees</option>
                                  {el.subFeeData?.map((opt, ind) => (
                                    <option
                                      key={ind}
                                      value={JSON.stringify(opt)}
                                    >
                                      {opt.SubFeeName}
                                    </option>
                                  ))}
                                  <option
                                    style={{ color: "blue" }}
                                    value={"Create new fee"}
                                  >
                                    Create new fee
                                  </option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                  {errors.subFee}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            {values.subFee === "Create new fee" && (
                              <Col className="px-1 my-2" xs={6} lg>
                                <Form.Group className="text-start">
                                  <Form.Control
                                    name="subFeeNameAlias"
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    value={values.subFeeNameAlias}
                                    onChange={handleChange}
                                    maxLength={25}
                                    onBlur={handleBlur}
                                    isInvalid={
                                      touched.subFeeNameAlias &&
                                      values.subFeeNameAlias === ""
                                    }
                                    type="text"
                                    placeholder="Fees name"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter fee name
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            )}
                          </>
                        )}
                        <Col className="px-1 my-2" xs={6} lg>
                          <Form.Group className="text-start">
                            <Form.Select
                              className="rounded-0 py-1"
                              style={Fontstyling.label}
                              name="feeType"
                              value={values.feeType}
                              onChange={(e) => {
                                handleChange(e);
                                //setLength20Error((prev) => ({ ...prev, [witchFees]: false }));
                                setFeeTypeError(false);
                              }}
                              onBlur={handleBlur}
                              isInvalid={
                                values.feeType === "Select Fees Type" &&
                                touched.feeType
                              }
                            >
                              <option value={""}>Select Fees Type</option>
                              {el.FeeID === 10
                                ? feeTypes
                                    ?.filter((f) => f.FeeTypeGroup === 1)
                                    .map((ft, ind) => (
                                      <option
                                        key={ind}
                                        value={JSON.stringify(ft)}
                                      >
                                        {ft.FeeTypeName}
                                      </option>
                                    ))
                                : feeTypes?.map((ft, ind) => (
                                    <option
                                      key={ind}
                                      value={JSON.stringify(ft)}
                                    >
                                      {ft.FeeTypeName}
                                    </option>
                                  ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.feeType}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col className="px-1 my-2" xs={6} lg>
                          <Form.Group className="text-start">
                            <Form.Control
                              name="feeTypeNameAlias"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.feeTypeNameAlias}
                              onChange={handleChange}
                              maxLength={25}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.feeTypeNameAlias &&
                                errors.feeTypeNameAlias
                              }
                              type="text"
                              placeholder="Fees Type Alias"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.feeTypeNameAlias}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col className="px-1 my-2" xs={6} lg>
                          <Form.Group className="text-start">
                            <InputGroup>
                              <InputGroup.Text className="py-0 fw-bold">
                                $
                              </InputGroup.Text>
                              <Form.Control
                                name="amount"
                                className="py-1 rounded-0"
                                style={Fontstyling.label}
                                value={values.amount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={touched.amount && errors.amount}
                                type="text"
                                maxLength={10}
                                placeholder="Amount"
                              />
                            </InputGroup>
                            {touched.amount && errors.amount && (
                              <div
                                className="text-danger pt-2"
                                style={Fontstyling.label}
                              >
                                {errors.amount}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        {witchFees === "Budgeted Rates" && (
                          <Col className="px-1 my-2" xs={6} lg>
                            <Form.Group className="text-start">
                              <Form.Control
                                className="rounded-0 py-1"
                                style={{
                                  ...Fontstyling.label,
                                  textTransform: "uppercase",
                                }}
                                type="date"
                                name="budgetedMonth"
                                // placeholder="Authorized User"
                                value={values.budgetedMonth}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={
                                  errors.budgetedMonth && touched.budgetedMonth
                                }
                              />

                              <Form.Control.Feedback type="invalid">
                                {errors.budgetedMonth}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        )}

                        <Col className="mx-2 my-2 d-flex align-items-baseline">
                          <button
                            className="btn p-0 m-0 rounded-circle border-0"
                            type="submit"
                          >
                            <img
                              src={AddIcon}
                              alt="add plus icon"
                              className="cursor-pointer"
                              width={24}
                            />
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
                {length20Error[witchFees] ? (
                  <div className="text-danger" style={Fontstyling.label}>
                    You can't add more than 20 fees
                  </div>
                ) : (witchFees == "Administrative Fee (ASO Fee)" ||
                    witchFees == "Administrative Fee") &&
                  FeeTypeError ? (
                  <div className="text-danger" style={Fontstyling.label}>
                    Fees type already exists
                  </div>
                ) : null}
                {/* {console.log({ feesArrays })} */}
                <div className="row">
                  {feesArrays[witchFees]?.map((item, index) => (
                    <FeesBadge
                      item={item}
                      feesArrays={feesArrays}
                      setFeesArrays={setFeesArrays}
                      key={index}
                      witchFees={witchFees}
                      setLength20Error={setLength20Error}
                    />
                  ))}
                </div>
              </div>
            );
          })}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex align-items-center justify-content-end gap-3">
          <button
            ref={buttonRef}
            style={Fontstyling.savebutton}
            type="submit"
            form="form1"
          >
            save
          </button>
          <button
            style={Fontstyling.cancelbutton}
            type="reset"
            onClick={() => {
              // resetForm();
              onHide();
            }}
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default VisionPlanModal;
